// extracted by mini-css-extract-plugin
module.exports = {"EvaluationList":"_3dtjIAM3t3q9HKHIOQ19ZM"};